import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import {
  FiLogOut,
  FiUsers,
  FiSettings,
  FiPackage,
  FiGrid,
  FiLayers,
  FiHome,
  FiBox,
  FiBarChart2,
  FiPercent,
  FiChevronDown,
  FiChevronUp
} from 'react-icons/fi';
import useAuth from '../../../hooks/useAuth';

const NavbarAdmin = ({ slug }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [productDropdownOpen, setProductDropdownOpen] = useState(false);
  const { signOutUser, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    console.group('[NavbarAdmin] 🔒 Déconnexion déclenchée');
    console.log('[NavbarAdmin] ➡️ Utilisateur courant :', user);
    console.log('[NavbarAdmin] ➡️ Token sessionStorage:', sessionStorage.getItem('access_token'));
    console.log('[NavbarAdmin] ➡️ Client ID sessionStorage:', sessionStorage.getItem('client_id'));

    await signOutUser('NavbarAdmin logout');

    console.log('[NavbarAdmin] ✅ Token après déconnexion:', sessionStorage.getItem('access_token'));
    console.log('[NavbarAdmin] ✅ Client ID après déconnexion:', sessionStorage.getItem('client_id'));
    console.log('[NavbarAdmin] ✅ Déconnexion terminée');
    console.groupEnd();

    navigate('/signin');
  };

  const links = [
    { to: `/admin/${slug}`, label: 'Tableau de Bord', icon: <FiHome size={20} /> },
    { to: `/admin/${slug}/utilisateurs`, label: 'Utilisateurs', icon: <FiUsers size={20} /> },
    { to: `/admin/${slug}/commandes`, label: 'Commandes', icon: <FiPackage size={20} /> },
    { to: `/admin/${slug}/categories`, label: 'Catégories', icon: <FiGrid size={20} /> },
    { to: `/admin/${slug}/sous-categories`, label: 'Sous-catégories', icon: <FiLayers size={20} /> },
    { dropdown: true, label: 'Produits', icon: <FiBox size={20} /> },
    { to: `/admin/${slug}/rapports`, label: 'Rapports', icon: <FiBarChart2 size={20} /> },
    { to: `/admin/${slug}/parametres`, label: 'Paramètres', icon: <FiSettings size={20} /> },
  ];

  return (
    <header className="bg-paragaia text-white flex items-center justify-between p-4 md:hidden shadow-lg fixed top-0 left-0 w-full z-50 h-20">
    <Link
      to={`/admin/${slug}`}
      onClick={() => setMenuOpen(false)}
      className="flex items-center space-x-3"
    >
      <img src="/assets/favicon.png" alt="Logo" className="w-10 h-10" />
      <span className="text-xl font-bold tracking-wide">Admin Panel</span>
    </Link>


      <button onClick={() => setMenuOpen(!menuOpen)} className="focus:outline-none">
        {menuOpen ? <XMarkIcon className="w-8 h-8" /> : <Bars3Icon className="w-8 h-8" />}
      </button>

      {menuOpen && (
        <div className="absolute top-20 left-0 w-full bg-paragaiaLight shadow-md z-40">
          <nav className="flex flex-col space-y-2 p-4">
            {links.map((link, index) =>
              link.dropdown ? (
                <div key={index}>
                  <button
                    onClick={() => setProductDropdownOpen(!productDropdownOpen)}
                    className="flex items-center justify-between w-full p-3 text-paragaia font-semibold rounded hover:bg-paragaia hover:text-white transition-all"
                  >
                    <div className="flex items-center space-x-3">
                      {link.icon}
                      <span>{link.label}</span>
                    </div>
                    {productDropdownOpen ? <FiChevronUp size={16} /> : <FiChevronDown size={16} />}
                  </button>
                  {productDropdownOpen && (
                    <div className="ml-8 mt-1 flex flex-col space-y-1">
                      <Link
                        to={`/admin/${slug}/produits`}
                        onClick={() => setMenuOpen(false)}
                        className="flex items-center space-x-2 p-2 text-paragaia rounded hover:bg-paragaia hover:text-white transition-all"
                      >
                        <FiBox size={16} />
                        <span>Liste des Produits</span>
                      </Link>
                      <Link
                        to={`/admin/${slug}/produits-promo`}
                        onClick={() => setMenuOpen(false)}
                        className="flex items-center space-x-2 p-2 text-paragaia rounded hover:bg-paragaia hover:text-white transition-all"
                      >
                        <FiPercent size={16} />
                        <span>Produits en Promo</span>
                      </Link>
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  key={link.to}
                  to={link.to}
                  className="flex items-center space-x-3 p-3 text-paragaia font-semibold rounded hover:bg-paragaia hover:text-white transition-all"
                  onClick={() => setMenuOpen(false)}
                >
                  {link.icon}
                  <span>{link.label}</span>
                </Link>
              )
            )}

            <button
              onClick={handleLogout}
              className="flex items-center space-x-3 p-3 w-full text-paragaia font-semibold rounded hover:bg-paragaia hover:text-white transition-all"
            >
              <FiLogOut size={20} />
              <span>Déconnexion</span>
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default NavbarAdmin;
